import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { CustomCheckboxProps } from './Checkbox';
import { focusStyle } from '../styles/mixins';
import { hexToRgbA, StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => {

  return createStyles({
  root: {
    display: ({hideIcon}:CustomCheckboxProps) => hideIcon ? 'none' : '',
    position: 'relative',
    marginRight: 8,
    width: 24,
    height: 24,
    '&.MuiCheckbox-root': {
      backgroundColor: theme.color.greys[0],
      borderRadius: 0,
      '&.Mui-checked:hover': {
        backgroundColor: 'transparent',
      },
    },
    '& svg': {
      height: 24,
      width: 24,
      overflow: 'visible',
      '& rect': {
        fill: 'transparent',
        stroke: theme.color.greys[40],
        strokeWidth: 2,
      },
      '& path': {
        stroke: 'transparent',
      },
    },
    '& $checkedIcon': {
      '& rect': {
        fill: theme.color.oranges[50],
        stroke: theme.color.oranges[50],
        strokeWidth: 2,
      },
      '& path': {
        stroke: theme.color.greys[0],
      },
    },
    '&.Mui-disabled': {
      '& $checkboxIcon': {
        '& rect': {
          fill: 'transparent',
          stroke: hexToRgbA(theme.color.greys[40], 0.4),
        },
        '& path': {
          stroke: 'transparent',
        },
      },
      '& $checkedIcon': {
        opacity: 0.4,
        '& svg': {
          opacity: 0.4,
        },
      },
    },
    '&.Mui-focusVisible': {
      ...focusStyle(theme),
      borderRadius: 0,
    },
    '&$error': {
      '& svg rect': {
        stroke: theme.color.reds[100],
      },
      '& $checkedIcon': {
        '& rect': {
          fill: theme.color.reds[100],
          stroke: theme.color.reds[100],
          strokeWidth: 2,
        },
        '& path': {
          stroke: theme.color.greys[0],
        },
      },
      '&:hover': {
        '& svg rect': {
          stroke: theme.color.reds[100],
        },
      },
    },
  },
  checkboxIcon: {},
  checkedIcon: {},
  error: {}
})}, { name: 'Checkbox', index: StylesIndexInjections.UI_ATOMS });
